
import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  EventEmitter,
  Output
}                       from '@angular/core';
;
import { ActionService         } from "@/services/action.service";

import {BrightnessResetAction} from "@/components/krpano/actions/brightness.reset.action";


@Component({
  standalone: false,
  selector:    'pano-brightness',
  template: `
    <div class="knob-wrapper">
      <p-knob
        id="brightness-knob"
        [(ngModel)]="_brightness"
        [size]="140"
        [min]="0"
        [max]="200"
        [step]="1"
        valueTemplate="{{percent()}}%"
        textColor="white"
        [valueColor]="strokeColor"
        (onChange)="onChange()">
      </p-knob>
      <div class="knob-icon"><img (click)="reset()" src="/assets/images/brightness-24.png"></div>
    </div>`

})

/**
 *
 * @class PanoramaBrightnessComponent
 *
 * @brief brightness filter on top of the panoramic viewer
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2022
 *
 */
export class PanoramaBrightnessComponent implements OnInit, OnDestroy, AfterViewInit {

  public min: number         = 0.0;
  public max: number         = 200;
  public _brightness: number = 100;
  public strokeColor: string = 'rgba(41, 170, 226, 0.38)';

  @Output() brightness_event = new EventEmitter<number>();

  constructor(
    private actions: ActionService
  ) {

    this.actions.add(new BrightnessResetAction(this));
  }

  ngOnInit() {


  }

  percent(): number {

    return Math.round(this._brightness);
  }

  /** fetch the css brightness filter value (0.0 - 2.0) */
  brightness(): number {

    return this._brightness / 100.0;
  }

  reset() {

    this._brightness = 100;
    this.onChange()
  }

  ngOnDestroy() {

  }

  ngAfterViewInit() {

  }

  onChange() {

    this.brightness_event.emit(this.brightness());
  }
}
